import { IRootState } from '../../../store'
import { ILabsOptionsState } from '../store/options.types'

export const getLabsConfigOptionsSelector = (state: IRootState): ILabsOptionsState => state.options.labsOptions
